import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "react-bootstrap";

export default function createNew() {
  return (
    <>
      <div className="mt-5">
        <Dropdown as={ButtonGroup}>
          <DropdownToggle variant="danger" id="dropdown-split-basic">
            Create New{" "}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem href="/show">Show</DropdownItem>
            <DropdownItem href="/ticket">Ticket Group Code</DropdownItem>
            <DropdownItem href="/seat-plan">Seat Plan</DropdownItem>
            <DropdownItem href="/ticket-prices">Ticket Prices</DropdownItem>
            <DropdownItem href="/buy-link">Buy Links</DropdownItem>
            <DropdownItem href="/gallery">Albums</DropdownItem>
            <DropdownItem href="/video">Video</DropdownItem>
            <DropdownItem href="/news-media">News & Media</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </>
  );
}
